import type { InterventionFollowupDropdownProps } from "./intervention-followup-dropdown.type";

import { DownOutlined } from "@ant-design/icons";
import { Button, Dropdown, Space } from "antd";
import { VscArrowSwap } from "react-icons/vsc";

import { useInterventionFollowupDropDown } from "./intervention-followup-dropdown.hook";

import "./intervention-followup-dropdown.style.less";

export const InterventionFollowupDropdown = ({
  intervention,
  ...buttonProps
}: InterventionFollowupDropdownProps) => {
  const { label, menuItems, renderPopup } = useInterventionFollowupDropDown({
    intervention,
  });

  return (
    <Dropdown
      rootClassName="follow-up-actions"
      menu={{
        items: menuItems,
        selectable: true,
        defaultSelectedKeys: [`version-${intervention.id}`],
      }}
      popupRender={renderPopup}
    >
      <Button icon={<VscArrowSwap />} {...buttonProps}>
        <Space>
          {label}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
};
